import React, { useContext, useEffect, useState } from 'react'
import Layout from '../../common/layout/layout'
import { Row, Col } from 'react-bootstrap'
import styles from './index.module.css'
import ContactItem from './contactItem'
import { AuthContext } from '../../../contexts/authContext'
import { getRecipients } from '../../../services/migrantService'
import { Recipient } from '../../../models/Recipient'

function Index() {
  const authContext = useContext(AuthContext)!
  const [recipients, setRecipients] = useState<Recipient[]>([])

  useEffect(() => {
    if (authContext.user?.uid) {
      getRecipients(authContext.user.uid).then(allRecipients => {
        setRecipients(allRecipients)
      })
    }
  }, [authContext.user])

  return (
    <div className="">
      <Layout>
        <Row>
          <Col>
            <h1 className="pageTitle">Recipients</h1>
          </Col>
        </Row>
        <Row
          className={
            recipients.length === 0 ? `pt-3` : `pt-3 ${styles.bottomRowBorder}`
          }
          data-testid="contact-card-row"
        >
          {recipients.length === 0 ? (
            <Col xs={12}>
              <p>No recipients found.</p>
            </Col>
          ) : null}
          {recipients.map((recipient, index) => {
            return (
              <ContactItem
                key={index}
                contactName={`${recipient.firstName} ${recipient.lastName}`}
                address={recipient.address.address1}
                id={recipient.id}
              />
            )
          })}
        </Row>
      </Layout>
    </div>
  )
}

export default Index
